import { installDataWedgeProfile } from "./datawedgeProfile";
import { setLuxonDefaults } from "./getActiveLocale";
import { setupOrientationLock } from "./setupOrientationLock";

setLuxonDefaults();
setupOrientationLock();
installDataWedgeProfile();
